import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  DocumentElement,
  GedService,
} from '../../../../pages/application/admin/playground/docuware-playground/ged.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { FileSaverService } from 'ngx-filesaver';
import { StringHelper } from '../../../helpers/string.helper';

@Component({
  selector: 'vex-drop-zone',
  templateUrl: './drop-zone.component.html',
  styleUrls: ['./drop-zone.component.scss'],
})
export class DropZoneComponent implements OnInit {
  static readonly SUPPORTED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf'];
  focusDropzone = false;
  @Input() files: DocumentElement[] = [];

  @Output() onFileDropped = new EventEmitter<any>();

  readonly acceptExtensions = DropZoneComponent.SUPPORTED_EXTENSIONS.map(ext => `.${ext}`).join(',');

  constructor(
    private snackbarService: SnackbarService,
    private _gedService: GedService,
    public fileSaver: FileSaverService,
  ) {}

  ngOnInit(): void {}

  fileDropped($event: any) {
    const rejectedFiles: string[] = [];
    for (const item of $event) {
      if (this.isExtensionSupported(item.name)) {
        this.files.push(this.prepareDocument(item));
      } else {
        rejectedFiles.push(item.name);
      }
    }
    if (rejectedFiles.length > 0) {
      const extensions = DropZoneComponent.SUPPORTED_EXTENSIONS.join(', ');
      this.snackbarService.danger(
        `Fichier(s) refusé(s) : ${rejectedFiles.join(', ')}. Extensions acceptées : ${extensions}`,
      );
    }
    this.onFileDropped.emit(this.files);
  }

  private isExtensionSupported(filename: string): boolean {
    const match = filename.match(/\.([^.]+)$/);
    if (!match) return false;
    return DropZoneComponent.SUPPORTED_EXTENSIONS.includes(match[1].toLowerCase());
  }

  onFileSelected($event: any) {
    this.fileDropped($event.target.files);
    // Réinitialiser l'input pour permettre la sélection du même fichier à nouveau
    $event.target.value = '';
  }

  deleteFileInList(index) {
    this.files.splice(index, 1);
  }

  private prepareDocument(file: File) {
    const sanitizedFileName = StringHelper.sanitizeFileName(file.name);
    return {
      id: this.uuidv4(),
      dateUpload: new Date().toISOString(),
      originalFileName: sanitizedFileName,
      size: file.size,
      contentType: file.type,
      status: 'IMPORTING',
      _file: file,
      progress: new BehaviorSubject<number>(0),
      uploadError: '',
      errorType: '',
    };
  }

  private uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  downloadDocument(id) {
    this._gedService.downloadDocument(id).subscribe((res: any) => {
      this.fileSaver.save(res.body, res.headers.get('filename'));
    });
  }
}
